import { Structure } from "@docma-mm-core/structure/structure";
import { Plan } from '@docma-mm-core/plan/plan';


export function sortPlans(structureList: Structure[], planList: Plan[]) {
  let sortedPlans = [];

  structureList.forEach(struct => {
    const plans = planList.filter(plan => plan.data.Structure.Id === struct.Id);
    addPlanStructurePath(plans, struct);
    sortedPlans = [...sortedPlans, ...plans];
  })

  return sortedPlans;
}

export function addPlanStructurePath(planList: Plan[], struct: Structure) {
  planList.forEach(plan => plan.data.StructurePath = struct.StructurePath);
}

export function getChildPlansOfStructure(selectedStructure: Structure, planList: Plan[]): Plan[] {
  let structures = [];
  if(selectedStructure.getFlatSortedStructures) {
    structures = selectedStructure.getFlatSortedStructures();
  }
  let childPlans = [];
  structures.forEach(struct => {
    const plans = planList.filter(plan => plan.data.Structure.Id === struct.Id);
    childPlans = [...childPlans, ...plans];
  });

  return childPlans;
}


export function getParentPlansOfStructure(selectedStructure: Structure, treeStructure: Structure, planList: Plan[]): Plan[] {
  const parentPlans: Plan[] = [];

  do {
    selectedStructure = new Structure(treeStructure).findById(selectedStructure?.Parent?.Id);

    planList.filter((plan) => {
      if (plan.data.Structure.Id  === selectedStructure?.Id) {
        parentPlans.push(plan);
      }
    });
  } while (parentPlans.length === 0 && selectedStructure?.Id !== selectedStructure?.RootId);

  return parentPlans;
}
